import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';

export const fetchAllCards = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.OPRATIONAL_CP.GET_OPERATIONAL_CP}`, { params: { ...data } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchSingleCards = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.OPRATIONAL_CP.GET_INDIVIDUAL_OPERATIONAL_CP}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchDynamicRowColumnDetails = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.OPRATIONAL_CP.GET_DYNAMIC_ROW_COLUMN_DETAILS}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchAllSuppliers = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER_SUGGESTION.GET_SUPPLIER}`, { params: { ...data } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addCardToCP = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.OPRATIONAL_CP.ADD_UPDATE_CP}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addRowsToCP = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.OPRATIONAL_CP.ADD_ROWS_IN_CP}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addColumnsToCP = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.OPRATIONAL_CP.ADD_UPDATE_COLUMNS_IN_CP}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getRowsofCP = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.OPRATIONAL_CP.ADD_ROWS_IN_CP}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getColumnsofCP = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.OPRATIONAL_CP.ADD_UPDATE_COLUMNS_IN_CP}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateCardToCP = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.OPRATIONAL_CP.ADDD_UPDATE_CP}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteOprationalCP = async (params) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.OPRATIONAL_CP.DELETE_OPRATIONAL_CP}`, {
      ...params,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteOprationalCPRows = async (params) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.OPRATIONAL_CP.DELETE_OPRATIONAL_CP_ROWS}`, {
      ...params,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteOprationalCPColumns = async (params) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.OPRATIONAL_CP.DELETE_OPRATIONAL_CP_COLUMNS}`, {
      ...params,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const manualDataAdded = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.OPRATIONAL_CP.SAVE_MANUAL_DETAILS}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const duplicateOCP = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.OPRATIONAL_CP.DUPLICATE_OPERATIONAL_CP}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const lastOpenedModal = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.OPRATIONAL_CP.LAST_OPENED}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getActiveColumnsofCP = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.OPRATIONAL_CP.ADD_UPDATE_COLUMNS_IN_CP}/${id}?isActive=true`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const downloadOCPExcelService = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.OPRATIONAL_CP.OCP_EXCEL_SHEET_DOWNLOAD}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};
